import React from "react";

function Safari() {
  return (
    <div>
      <h3
        id="enabling-safari-location-services-mac"
        class="intercom-align-center"
        data-post-processed="true"
      >
        Enabling Safari Location Services (Mac)
      </h3>
      <p class="no-margin">
        1. Start by clicking the <strong>Apple </strong>symbol in the upper
        left-hand corner followed by <strong>System Preferences</strong>:
      </p>
      <p class="no-margin">
        2. Then click <strong>Security &amp; Privacy</strong>:
      </p>
      <p class="no-margin">
        3. Then click the <strong>Privacy </strong>tab:
      </p>
      <p class="no-margin">
        4. Click on the padlock in the bottom left-hand corner of the window.
        You will be asked to authenticate by entering your computer ID/password.
        Once entered, you will then be able to adjust your Location Services by
        checking the box next to <strong>Enable Location Services</strong> and
        ensuring location services are enabled specifically for{" "}
        <strong>Safari</strong>:
      </p>
      <p class="no-margin">&nbsp;5. Click the lock again once done.</p>
    </div>
  );
}

export default Safari;
